<template>
    <div class="container">
      <h1>Linux CheatSheet</h1>
      <p class="description">Uma referência rápida para comandos essenciais do Linux.</p>
  
      <div class="cheat-sheet">
        <!-- Primeira Coluna -->
        <div class="column">
          <h2>📌 Conceitos Básicos</h2>
          <p><b>Linux:</b> Sistema operacional open-source baseado em UNIX.</p>
          <p><b>Shell:</b> Interface de linha de comando para interagir com o sistema.</p>
          <p><b>Bash:</b> Um dos shells mais usados no Linux.</p>
          <p><b>Root:</b> Usuário administrador com acesso total ao sistema.</p>
          <p><b>Home:</b> Diretório pessoal de cada usuário (<code>/home/usuario</code>).</p>
  
          <h2>📌 Gerenciamento de Arquivos</h2>
          <p><b>Listar arquivos:</b> <code>ls</code></p>
          <p><b>Listar detalhes:</b> <code>ls -l</code></p>
          <p><b>Mudar de diretório:</b> <code>cd pasta</code></p>
          <p><b>Voltar um nível:</b> <code>cd ..</code></p>
          <p><b>Copiar arquivos:</b> <code>cp arquivo destino/</code></p>
          <p><b>Mover arquivos:</b> <code>mv arquivo destino/</code></p>
          <p><b>Renomear arquivos:</b> <code>mv arquivo_novo arquivo_antigo</code></p>
          <p><b>Remover arquivos:</b> <code>rm arquivo</code></p>
          <p><b>Remover diretório:</b> <code>rm -r pasta</code></p>
  
          <h2>📌 Permissões</h2>
          <p><b>Alterar permissões:</b> <code>chmod 755 arquivo</code></p>
          <p><b>Alterar dono do arquivo:</b> <code>chown usuario:grupo arquivo</code></p>
          <p><b>Executar comando como root:</b> <code>sudo comando</code></p>
        </div>
  
        <!-- Segunda Coluna -->
        <div class="column">
          <h2>📌 Conceitos Básicos (Continuação)</h2>
          <p><b>Filesystem:</b> Organização de arquivos e diretórios no Linux.</p>
          <p><b>Terminal:</b> Programa usado para interagir com o shell.</p>
          <p><b>Mount:</b> Processo de conectar dispositivos ao sistema (<code>mount /dev/sdb1 /mnt</code>).</p>
          <p><b>Package Manager:</b> Gerenciador de pacotes do sistema (<code>apt</code>, <code>dnf</code>, <code>pacman</code>).</p>
          
          <h2>📌 Gerenciamento de Processos</h2>
          <p><b>Exibir processos em execução:</b> <code>ps aux</code></p>
          <p><b>Finalizar processo:</b> <code>kill PID</code></p>
          <p><b>Forçar encerramento:</b> <code>kill -9 PID</code></p>
          <p><b>Monitorar processos:</b> <code>top</code></p>
          <p><b>Saída do <code>top</code>:</b> Pressionar <code>q</code></p>
  
          <h2>📌 Gerenciamento de Usuários</h2>
          <p><b>Criar usuário:</b> <code>useradd nome</code></p>
          <p><b>Definir senha:</b> <code>passwd nome</code></p>
          <p><b>Remover usuário:</b> <code>userdel nome</code></p>
          <p><b>Adicionar usuário a grupo:</b> <code>usermod -aG grupo usuario</code></p>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .container {
    max-width: 900px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: "Arial", sans-serif;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .cheat-sheet {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  
  .column {
    width: 48%;
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    text-align: left;
    line-height: 1.6;
  }
  
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
    color: #007bff;
  }
  
  p {
    font-size: 14px;
    margin: 8px 0;
  }
  
  code {
    background: #e3e3e3;
    padding: 3px 5px;
    border-radius: 5px;
    font-family: monospace;
  }
  </style>
  